import { render } from "./SectionV3.vue?vue&type=template&id=601f0688"
import script from "./SectionV3.vue?vue&type=script&lang=js"
export * from "./SectionV3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__